import { createApp } from 'vue';
import { createPinia } from 'pinia';
import App from './App.vue';
import { initializeModuleRoutes, router } from './router';
import { i18n } from './i18n';
import { useAuthStore } from '@/stores/auth';
import { useThemeStore } from '@/stores/theme';
import { useLocaleStore } from '@/stores/locale';
import './style.css';

const app = createApp(App);
const pinia = createPinia();
app.use(pinia);
app.use(i18n);

// Тема и локаль — синхронно до маунта, чтобы не было flash-of-unstyled-content
// и моргания английского/русского при первом рендере.
useThemeStore().bootstrap();
useLocaleStore().bootstrap();

const auth = useAuthStore();
async function bootstrap() {
    await auth.bootstrap();
    if (auth.isAuthenticated) await initializeModuleRoutes();

    app.use(router);
    await router.isReady();
    app.mount('#app');
}

void bootstrap().catch(error => {
    console.error('Network bootstrap failed', error);
    const loader = document.querySelector('.bootstrap-loader');
    if (!loader) return;
    const message = document.createElement('p');
    message.textContent = 'Не удалось загрузить панель. Проверьте соединение и повторите попытку.';
    const retry = document.createElement('button');
    retry.textContent = 'Повторить загрузку';
    retry.className = 'btn-cta';
    retry.onclick = () => window.location.reload();
    loader.replaceChildren(message, retry);
});
